<template>
  <v-layout column>
    <v-form>
      <v-flex xs12 sm12 md12>
        <AuctionForm @submit="submit" :isDisabledSubmit="isDisabledSubmit" ref="auctionForm" />
      </v-flex>
    </v-form>
  </v-layout>
</template>
<script>
import AuctionForm from '@/components/forms/auctionForm.vue';
import AuctionsService from '@/services/AuctionsService';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'auctionEdit',
  data() {
    return {
      isDisabledSubmit: false,
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  methods: {
    ...mapActions(['showSnackbar']),
    submit(data, image, ifImageRemove) {
      if (data === 'auctionEdit') {
        this.isDisabledSubmit = true;
        let imagesData = new FormData();
        if (image.imageFile || ifImageRemove) {
          imagesData.append('image', image.imageFile);
        }
        let jsonToSend = this.$refs.auctionForm.getJSONtoSubmit();
        if (
          this.$refs.auctionForm.$refs.form.validate() &&
          this.$refs.auctionForm.formValidation()
        ) {
          AuctionsService.patchAuctionDetail(this.id, jsonToSend)
            .then(() => {
              this.isDisabledSubmit = false;
              AuctionsService.patchAuctionDetail(this.id, imagesData);
              this.$router.push({ name: 'auctionDetail', params: { id: this.id } });
            })
            .catch((error) => {
              this.isDisabledSubmit = false;
              this.showSnackbar(error.response.data.detail);
              console.log(error.response.statusText);
            });
        }
      }
    },
  },
  computed: {
    ...mapState(['apiUrl']),
  },
  components: {
    AuctionForm,
  },
  mounted() {
    AuctionsService.getAuctionDetail(this.id)
      .then((response) => {
        let auctionData = response.data;
        this.$refs.auctionForm.value = auctionData.value;
        this.$refs.auctionForm.minimalStep = auctionData.minimalStep;
        this.$refs.auctionForm.title = auctionData.title;
        this.$refs.auctionForm.description = auctionData.description;
        this.$refs.auctionForm.currency = auctionData.currency;
        if (auctionData.image) {
          this.$refs.auctionForm.auctionLogoServer =
            this.apiUrl.substring(0, this.apiUrl.length - 1) + auctionData.image;
        }
      })
      .catch((error) => {
        console.log(error.response.statusText);
      });
  },
};
</script>
<style>
.submit-button-container {
  margin-top: 30px;
}

.back-button {
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}
</style>
